export const Pages = {
  checkout: "/checkout",
};
